import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/FirebaseAuthContext';
import { useVerificationCheck } from '../../hooks/useVerificationCheck';
import LoadingSpinner from '../socialmessaging/LoadingSpinner';

/**
 * Wrapper for "Public" routes that should still block UNVERIFIED LOGGED-IN users.
 * 
 * Behavior:
 * - Loading -> Spinner
 * - Anonymous (Not Logged In) -> Allowed (Render Children)
 * - Logged In & Verified -> Allowed (Render Children)
 * - Logged In & Unverified -> Redirect to /verify-email
 */
const VerificationGuard = ({ children }) => {
    const { user, loading: authLoading } = useAuth();
    const { needsVerification, loading: verificationLoading } = useVerificationCheck();
    const location = useLocation();

    if (authLoading || verificationLoading) {
        return (
            <div className="flex justify-center items-center min-h-screen">
                <LoadingSpinner />
            </div>
        );
    }

    // Allow anonymous users (user is null)
    // Logic: "If new user signs [up], they should verify... anonymous user still gets access"
    if (!user) {
        return children;
    }

    // Block unverified logged-in users
    if (needsVerification) {
        return <Navigate to="/verify-email" state={{ from: location }} replace />;
    }

    // User is logged in and verified (or exempt)
    return children;
};

export default VerificationGuard;
